
  
  // export const basicauth={
  //   username: "info@seobix@bumppy@goseo",
  //   password: "goseo@bumppy@seobix@info",
  
  // }
  

  export const basicauth={
    username: process.env.REACT_APP_LOGIN_USERNAME,
    password: process.env.REACT_APP_LOGIN_PASSWORD,
  
  }
  // export const apibasicauth={
  //   username: "BUMPPY_SSO_SgLjvARJ5LbX",
  //   password: "tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq",
  
  // }
  export const apibasicauth = {
    username: process.env.REACT_APP_API_USERNAME,
    password: process.env.REACT_APP_API_PASSWORD,
  };